/*============================*/

/* Update main product image. */

/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {

// newImageSrc is the path of the new image in the same size as originalImage is sized.
// newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
// mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);
};

jQuery(function($) {

/* Placeholder JS */

/*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function() {
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });
  }

/* Form validation JS */

/*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

/* Remove SVG images to avoid broken images in all browsers that don't support SVG. */

/*==========================*/

  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }
  if (! supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }

/* Prepare to have floated images fill the width of the design on blog pages on small devices. */

/*==========================*/

  var images = $('.article img').on('load', function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });

/* Update main product image when a thumbnail is clicked. */

/*==========================*/
  $('.product-photo-thumb a').on('click', function(e) {
    e.preventDefault();
    $('.product-photo-thumb a').removeClass('active-thumb');
    $(this).addClass('active-thumb');
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  });


/*Product page*/


/* Collections */


  $('.filters-toggle').on('touchstart click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.collection-filters').toggleClass('opened');
    $(this).toggleClass('selected');
  });


  $('.filters-category-seasons').on('touchstart click', function(e) {
    if ($(window).width() <= 767) {
      e.stopPropagation();
      e.preventDefault();
      $(this).siblings('.filters-category-seasons').removeClass('selected');
      $(this).addClass('selected');
    }
  });

  $('.filters-category-design').on('touchstart click', function(e) {
    if ($(window).width() <= 767) {
      e.stopPropagation();
      e.preventDefault();
      $(this).siblings('.filters-category-design').removeClass('selected');
      $(this).addClass('selected');
    }
  });

  $('.filters-category-fabric').on('touchstart click', function(e) {
    if ($(window).width() <= 767) {
      e.stopPropagation();
      e.preventDefault();
      $(this).siblings('.filters-category-fabric').removeClass('selected');
      $(this).addClass('selected');
    }
  });

  $('.filters-category-price').on('touchstart click', function(e) {
    if ($(window).width() <= 767) {
      e.stopPropagation();
      e.preventDefault();
      $(this).siblings('.filters-category-price').removeClass('selected');
      $(this).addClass('selected');
    }
  });


  $('.filters-clear').on('touchstart click', function(e) {
    e.preventDefault();
    window.location = $(this).data('collection-url');
  });


  $(document).on("touchstart click", ".sort-options", function(e) {


    e.stopPropagation();
    e.preventDefault();

    if ($(".sort-by-options").hasClass("hide-options")) {
      $(".sort-by-options").removeClass("hide-options");
      $(this).addClass("selected")
    } else {
      $(".sort-by-options").addClass("hide-options");
      $(this).removeClass("selected")
    }

  });


  $(document).on("touchstart click", ".sort-by-options li", function(e) {

    e.stopPropagation();
    e.preventDefault();

    var target = $(this).data("for");
    var vTitle = $(this).html();

    if ($(this).hasClass("selected")) {

      $(this).parent().find("li").removeClass("selected");

// $(this).parent().parent().siblings(".sort-options").children(".sort-option").html("");
      $("option#" + target).prop('selected', false);

    } else {


      $(this).parent().find("li").removeClass("selected");
      $(this).addClass("selected");

// $(this).parent().parent().siblings(".sort-options").children(".sort-option").html($(this).html());
      $("option#" + target).prop('selected', true);
      $("#" + target).trigger("change");

    }

  });


  $('.sort-by select#sort-by-select').val('').on('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });


  var sorturl = location.search;


  if (sorturl.length > 0) {

    var sortoptionurl = sorturl.split('=');
    var sortoption = sortoptionurl[1];

    $(".sort-by-options ul li[data-value='" + sortoption + "']").addClass("selected");
    $(".sort-options").html($(".sort-by-options ul li[data-value='" + sortoption + "']").html());

  }


});


// AJAX CART
$('.prod-quick-add button').click(function(e) {
  var variant = $(this).data('variant');

  CartJS.addItem(variant, 1, {}, {

// Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $('header').addClass('cart-added');
      setTimeout(function() {
        $('header').removeClass('cart-added');
      }, 1000);
    },

// Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {

// $('#message').addClass('message-error');
// $('#message').html('There was a problem adding to the cart!');
    }

  });
});

$('#product-add #add').click(function(e) {
  e.preventDefault();
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).closest('form').serialize(),
    dataType: 'json',
    success: function() {
      window.location.href = '/cart';
      $('header').addClass('cart-added');
      setTimeout(function() {
        $('header').removeClass('cart-added');
      }, 1000);
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      $('#message').addClass('message-error');
      $('#message').html('There was a problem adding to the cart!');
    }
  });

});


$('.blog-features.mobile').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});

// Old filter logic removed - now handled by collection-filters.js.liquid
// Old sorter hover logic removed - now uses click behavior

$('.mobile-filter-toggle').on('touchstart click', function(e) {
  e.stopPropagation();
  e.preventDefault();

  if (!$('.mobile-filters-panel').hasClass('mobile-open')) {

// Opening
    $('.mobile-filters-panel').addClass('mobile-open');
    $('body').addClass('filter-open');
    $('.mobile-filter-toggle span').text('Close');
  } else {

// Closing
    $('.mobile-filters-panel').removeClass('mobile-open');
    $('body').removeClass('filter-open');
    $('.mobile-filter-toggle span').text('Filters');
  }
});

// Close filter panel when clicking the close button
$('.mobile-filters-close').on('touchstart click', function(e) {
  e.stopPropagation();
  e.preventDefault();
  $('.mobile-filters-panel').removeClass('mobile-open');
  $('body').removeClass('filter-open');
  $('.mobile-filter-toggle span').text('Filters');
});

// Close filter panel when clicking outside
$(document).on('touchstart click', function(e) {
  if ($('.mobile-filters-panel').hasClass('mobile-open') && !$(e.target).closest('.mobile-filters-panel').length && !$(e.target).closest('.mobile-filter-toggle').length) {
    $('.mobile-filters-panel').removeClass('mobile-open');
    $('body').removeClass('filter-open');
    $('.mobile-filter-toggle span').text('Filters');
  }
});

// Prevent filter panel from closing when clicking inside
$('.mobile-filters-panel').on('touchstart click', function(e) {

// Only stop propagation for events that aren't filter removal
  if (!$(e.target).hasClass('remove-filter') && e.target.id !== 'mobile-clear-all-filters') {
    e.stopPropagation();
  }
});